import { useState } from "react";
import { Mic, Paperclip, Trash2, ChevronDown } from "lucide-react";

const STATUS = {
  opened: ["Chat aperta", "text-primary"],
  pending: ["Non aperta", "text-[hsl(var(--c-fat))]"],
  no_phone: ["Senza telefono", "text-muted-foreground"],
};

function Item({ b, onDelete }) {
  const [open, setOpen] = useState(false);
  const opened = b.recipients.filter((r) => r.status === "opened").length;
  return (
    <div className="rounded-xl border border-white/10 bg-black/20" data-testid={`chat-history-item-${b.id}`}>
      <button onClick={() => setOpen((v) => !v)} className="flex w-full items-start gap-2 p-3 text-left" data-testid={`chat-history-toggle-${b.id}`}>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] text-muted-foreground">{new Date(b.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</div>
          <div className="mt-0.5 line-clamp-2 text-sm">{b.text || <span className="italic text-muted-foreground">(solo allegati)</span>}</div>
          <div className="mt-1 flex items-center gap-2 text-[11px] text-muted-foreground">
            {b.has_voice && <span className="inline-flex items-center gap-1"><Mic className="h-3 w-3" /> vocale</span>}
            {b.file_name && <span className="inline-flex items-center gap-1 truncate"><Paperclip className="h-3 w-3" /> {b.file_name}</span>}
            <span className="font-semibold text-foreground" data-testid={`chat-history-count-${b.id}`}>{opened}/{b.recipients.length} chat aperte</span>
          </div>
        </div>
        <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="space-y-1 border-t border-white/5 p-3">
          {b.recipients.map((r) => {
            const [label, cls] = STATUS[r.status] || STATUS.pending;
            return (
              <div key={r.patient_id} className="flex items-center justify-between text-xs" data-testid={`chat-history-recipient-${b.id}-${r.patient_id}`}>
                <span className="truncate">{r.name}</span>
                <span className={`font-semibold ${cls}`}>{label}{r.opened_at ? ` · ${new Date(r.opened_at).toLocaleTimeString("it-IT", { timeStyle: "short" })}` : ""}</span>
              </div>
            );
          })}
          <button onClick={() => onDelete(b)} className="mt-2 inline-flex items-center gap-1 text-[11px] text-muted-foreground hover:text-destructive" data-testid={`chat-history-delete-${b.id}`}><Trash2 className="h-3 w-3" /> Elimina dallo storico</button>
        </div>
      )}
    </div>
  );
}

export default function ChatHistory({ items, onDelete }) {
  if (!items.length) return <div className="rounded-lg border border-dashed border-white/10 py-10 text-center text-sm text-muted-foreground" data-testid="chat-history-empty">Nessun messaggio inviato.</div>;
  return <div className="space-y-2" data-testid="chat-history-list">{items.map((b) => <Item key={b.id} b={b} onDelete={onDelete} />)}</div>;
}
